import { render, staticRenderFns } from "./fpzPenalty.vue?vue&type=template&id=3aaf17ac"
import script from "./fpzPenalty.vue?vue&type=script&lang=js"
export * from "./fpzPenalty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports